var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381 944 c-108 -29 -231 -118 -231 -167 0 -22 16 -37 40 -37 5 0 30 19 57 42 82 71 142 93 253 93 88 0 101 -3 162 -33 256 -126 290 -472 63 -644 -70 -53 -133 -73 -230 -72 -101 1 -175 28 -244 90 -57 51 -94 57 -99 15 -5 -33 65 -102 143 -140 127 -63 273 -64 402 -4 77 36 180 139 216 216 82 174 50 371 -82 510 -120 126 -287 175 -450 131z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 597 c-45 -45 -82 -89 -82 -97 0 -20 161 -180 181 -180 20 0 39 20 39 40 0 9 -18 34 -41 55 l-40 40 192 5 c169 4 193 7 203 22 8 13 8 23 0 35 -10 16 -34 19 -203 23 l-192 5 40 40 c42 40 50 62 29 83 -23 23 -44 11 -126 -71z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5acc042730dbcd96714b0019f12dd58c.svg";
export { ForwardRef as ReactComponent };